import React from 'react';

import {
  fixedWidthStyle,
  stickyColumnStyle,
} from 'components/uikit/grids/gridCommons';
import { Flex } from 'components/uikit/reexport';

import { Box } from '../reexport';

export function WideRightColGrid({
  children: [col1, col2],
  stickyCols: [stickyCol1, stickyCol2] = [false, false],
}: {
  children: [React.ReactNode, React.ReactNode];
  stickyCols?: [boolean, boolean];
}) {
  const leftColSize = 194;
  const rightColSize = 1096;
  const xPadding = 16;
  const gridSize = 2 * xPadding + leftColSize + rightColSize;

  return (
    <Flex
      dir='row'
      width='100%'
      // This one is important for the scroll bar to appear on the page
      // instead of on this container
      height='auto'
      gap='8'
      justifyContent='center'
      //
      // the following is necessary for the user-friendly
      // horizontal scroll when the screen is too small
      {...fixedWidthStyle(gridSize)}
      margin='auto'
      //
    >
      <Box {...fixedWidthStyle(leftColSize)} {...stickyColumnStyle(stickyCol1)}>
        {col1}
      </Box>
      <Box
        {...fixedWidthStyle(rightColSize)}
        {...stickyColumnStyle(stickyCol2)}
        flex={1}
      >
        {col2}
      </Box>
    </Flex>
  );
}
